import { ServiceTier } from '@infura/packages.uks'

export const TierHierarchy: { [tier in ServiceTier]: number } = {
  [ServiceTier.CORE]: 0,
  [ServiceTier.DEVELOPER]: 1,
  [ServiceTier.TEAM]: 2,
  [ServiceTier.GROWTH]: 3,
  [ServiceTier.ENTERPRISE]: 4
}

export const TierPricing: { [tier in ServiceTier]: number } = {
  [ServiceTier.CORE]: 0,
  [ServiceTier.DEVELOPER]: 50,
  [ServiceTier.TEAM]: 225,
  [ServiceTier.GROWTH]: 1000,
  [ServiceTier.ENTERPRISE]: 0
}

/** actual project cap of plans with unlimted key limits */
export const UNLIMITED_API_KEYS = 500000
